export default __webpack_public_path__ + "static/media/testDrawing.c5069600.dxf";